export const LIST_TRAINING = `homepage/list-training`;
export const LIST_TRAINING_CERTIFICATE = `homepage/list-certificate`;